/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Searchreadyitemdescription3Inputs */

const en_searchreadyitemdescription3 = /** @type {(inputs: Searchreadyitemdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A description of at least 120 characters`)
};

const de_searchreadyitemdescription3 = /** @type {(inputs: Searchreadyitemdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung mit mindestens 120 Zeichen`)
};

/**
* | output |
* | --- |
* | "A description of at least 120 characters" |
*
* @param {Searchreadyitemdescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const searchreadyitemdescription3 = /** @type {((inputs?: Searchreadyitemdescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Searchreadyitemdescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_searchreadyitemdescription3(inputs)
	return de_searchreadyitemdescription3(inputs)
});
export { searchreadyitemdescription3 as "searchReadyItemDescription" }